import { Button, Avatar as AntdAvatar, Space, Tooltip } from 'antd'
import { SizeType } from 'antd/lib/config-provider/SizeContext'
import * as React from 'react'

import { AvatarListProps, AddUserButtonProps } from './types'

import { Avatar, AvatarButton, AvatarProps, AvatarSize } from '../avatar'

import * as styles from './AvatarList.module.less'

import { Icons } from '../icons'

const defaultMaxAvatarCount = 6
const defaultSmallWhiteBorder = 2
const defaultMediumAndLargeWhiteBorder = 3

export const AvatarList: React.FC<AvatarListProps> = (props) => {
    const {
        addUserBtn: AddUserBtn,
        avatars,
        onAvatarClick,
        onAvatarCountClick,
        onAddUserClick,
        size,
        whiteBorder
    } = props
    const maxAvatarCount = props.maxAvatarCount || defaultMaxAvatarCount

    const avatarCount = avatars.length
    const badgeCount = avatarCount - maxAvatarCount

    const showBadgeCount = avatarCount > maxAvatarCount

    let addUserButton = null
    if (AddUserBtn) {
        addUserButton = AddUserBtn
    } else if (onAddUserClick) {
        addUserButton = <AddUserButton onClick={onAddUserClick} size={size} />
    }

    const defaultWhiteBorder =
        size === 'small'
            ? defaultSmallWhiteBorder
            : defaultMediumAndLargeWhiteBorder

    return (
        <Space className={styles.avatarListWrapper}>
            {addUserButton}
            <div className={styles.avatarList}>
                {avatars
                    .slice(0, maxAvatarCount)
                    .reverse() // we reverse the list because CSS will use flex-direction: row-reverse
                    .map((a) => {
                        const avatarProps: AvatarProps = {
                            size: size,
                            whiteBorder: whiteBorder || defaultWhiteBorder,
                            ...a
                        }
                        const avatar = onAvatarClick ? (
                            <AvatarButton
                                key={a.id}
                                {...avatarProps}
                                onAvatarClick={onAvatarClick}
                            />
                        ) : (
                            <Avatar key={a.id} {...avatarProps} />
                        )
                        return avatar
                    })}
            </div>
            {showBadgeCount ? (
                <AvatarCount
                    key={'avatar-count'}
                    size={size}
                    whiteBorder={props.whiteBorder}
                    onClick={onAvatarCountClick}
                >
                    <div style={{ fontWeight: 'bold' }}>+{badgeCount}</div>
                </AvatarCount>
            ) : null}
        </Space>
    )
}

export interface AvatarCountProps {
    onClick?: () => void
    size?: AvatarSize
    whiteBorder?: number
}

const AvatarCount: React.FC<AvatarCountProps> = (props) => {
    const { children, onClick, size, whiteBorder } = props
    return (
        <span
            className={`avatarCount`}
            onClick={onClick}
            style={{ border: `${whiteBorder}px solid white` }}
        >
            <AntdAvatar size={size}>{children}</AntdAvatar>
        </span>
    )
}

export const AddUserButton: React.FC<AddUserButtonProps> = (props) => {
    const onAddUserClick = () => {
        if (props.onClick) {
            props.onClick()
        } else {
            console.warn('Please provide a onAddUserClick method to AvatarList')
        }
    }

    const size = (props.size?.toString().replace('default', 'middle') ||
        'middle') as SizeType

    return (
        <span className={`addUserButton`} onClick={onAddUserClick}>
            <Button
                shape="circle"
                icon={<Icons.User.AddTeamIcon />}
                size={size}
            />
        </span>
    )
}
